// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { Link } from '@tanstack/react-router';

// material ui
import { Button } from '@mui/material';

export default function HomeGetStartedButton() {
  const { t } = useTranslation('home');

  return (
    <Button
      component={Link}
      to="/account/create"
      variant="contained"
      size="large"
      disableElevation
      sx={{ mt: 4 }}
    >
      {t('home.getStarted')}
    </Button>
  );
}
